import {useFormContext} from '@yandex-delivery/nlf-form/v2'
import React from 'react'

// FIXME: Cannot find module './assets/lcv_l.png' or its corresponding type declarations.
import lcvLSrc1x from './assets/lcv_l@1x.png'
import lcvLSrc2x from './assets/lcv_l@2x.png'
import lcvLSrc3x from './assets/lcv_l@3x.png'
import lcvMSrc from './assets/lcv_m.png'
import lcvXLSrc1x from './assets/lcv_xl@1x.png'
import lcvXLSrc2x from './assets/lcv_xl@2x.png'
import lcvXLSrc3x from './assets/lcv_xl@3x.png'
import truck5tSrc1x from './assets/truck_5t@1x.png'
import truck5tSrc2x from './assets/truck_5t@2x.png'
import truck5tSrc3x from './assets/truck_5t@3x.png'
import unselectedSrc from './assets/unselected.png'
import vanImageSrc from './assets/van.png'
import * as classes from './CarBodyImage.classes'
import type {Props} from './CarBodyImage.types'
import {CarBodyType} from './CarBodyImage.types'

function CarBodyImageBase({name, getFallbackValue}: Props): React.ReactElement<Props> {
  const {watch} = useFormContext()
  const value: CarBodyType = watch(name)

  const mayBeSrc = getFallbackValue(value)

  if (mayBeSrc) {
    return <img alt="" className={classes.image} height={112} src={mayBeSrc} width="auto" />
  }

  switch (value) {
    case CarBodyType.Van:
    case CarBodyType.LCV_S_GLOBAL:
      return <img alt="" className={classes.image} height={112} src={vanImageSrc} width="auto" />
    case CarBodyType.LCV_L:
    case CarBodyType.LCV_L_GLOBAL:
      return (
        <img
          alt=""
          className={classes.image}
          height={112}
          src={lcvLSrc1x}
          srcSet={`${lcvLSrc2x} 2x, ${lcvLSrc3x} 3x`}
          width="auto"
        />
      )
    case CarBodyType.LCV_M_GLOBAL:
    case CarBodyType.LCV_M:
      return <img alt="" className={classes.image} height={112} src={lcvMSrc} width="auto" />
    case CarBodyType.LCV_XL:
      return (
        <img
          alt=""
          className={classes.image}
          height={112}
          src={lcvXLSrc1x}
          srcSet={`${lcvXLSrc2x} 2x, ${lcvXLSrc3x} 3x`}
          width="auto"
        />
      )
    case CarBodyType.TRUCK_5T:
      return (
        <img
          alt=""
          className={classes.image}
          height={112}
          src={truck5tSrc1x}
          srcSet={`${truck5tSrc2x} 2x, ${truck5tSrc3x} 3x`}
          width="auto"
        />
      )
    default:
      return <img alt="" className={classes.image} height={112} src={unselectedSrc} width="auto" />
  }
}

export const CarBodyImage = React.memo(CarBodyImageBase)
